import React, {useEffect, useState} from 'react';
import './styles/radiation.css'
import { VideoLoader} from '../components/UXHelper';
import { ExtinctionVideoData, ExtinctionData } from '../components/feactures/dataProvider';
import { LoadRadiationTable } from '../components/feactures/dataFetcher';
import { LayoutContainer } from './layouts/layout_bi_columns';
import { ModalNotify } from '../components/Modals';
import { FurnaceInv } from './Inventory';
import { ShopRpoints } from '../components/RA_shop';

export const JoinScreen = ({userData, setRdata, refLink, referrer}) => {

  const [referValue, setReferValue] = useState('');

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const handleChange = (evt) => {
    const {value} = evt.target;
    setReferValue(value)
  }

  const joinRAliance = async() => {
    let value = '';
    if(Number(referValue.length) < 1){
      value = ExtinctionData.EXTINCTION_CONTRACT;
    }
    else{
      value = referValue;
    }
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.EXTINCTION_CONTRACT,
          name: 'setrefer',
          authorization: [userData.auths],
          data: {
            account: userData.username,
            referred: value,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
          setRdata({
            status: true,
          })
        })
      }catch(err){

      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
                account: ExtinctionData.EXTINCTION_CONTRACT,
                name: 'setrefer',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  account: userData.username,
                  referred: value,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          setRdata({
            status: true,
          })
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('');
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }
  }

  const joinRAlianceLink = async() => {
    let value = referrer;
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.EXTINCTION_CONTRACT,
          name: 'setrefer',
          authorization: [userData.auths],
          data: {
            account: userData.username,
            referred: value,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
          setRdata({
            status: true,
          })

        })
      }catch(err){

      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
                account: ExtinctionData.EXTINCTION_CONTRACT,
                name: 'setrefer',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  account: userData.username,
                  referred: value,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          setRdata({
            status: true,
          })
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('');
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }
  }

  if(refLink){
    return (
      <div className='modal_container'>
          <div className='radiation_init_container'>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                  setNotify({
                      status: false,
                      error: false,
                      title: '',
                      msg: '',
                      txId: '',
                  })
                }}/>}
          <div className='init_structer_box_radiation'>
            <div className='init_header_structer'>
              <h2 className='welcome_title_init'>welcome</h2>
              <p className='init_username'>- {userData.username} - </p>
            </div>
            <div className='init_body_structer'>
              <div className='init_input_box'>
                <p className='msg_refererlink'>You have been invited by:</p>
                <h2 className='referrer_name'>{referrer}</h2>
              </div>
              <div className='init_action_btn_box'>
                <button className='alt_btn' onClick={() => joinRAlianceLink()}>Accept invitation</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)'}}>
      <div className='radiation_init_container'>
      {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        <div className='init_structer_box_radiation'>
          <div className='init_header_structer'>
            <h2 className='welcome_title_init'>welcome</h2>
            <p className='init_username'>- {userData.username} - </p>
          </div>
          <div className='init_body_structer'>
            <div className='init_input_box'>
              <span>Enter your referral's account:</span>
              <input type="text" placeholder='username' value={referValue} onChange={handleChange}/>
              <span className='init_note_input'>**If no one invited you, just press the buttom below.</span>
            </div>
            <div className='init_action_btn_box'>
              <button className='alt_btn' onClick={() => joinRAliance()}>Join the Radiation Alliance</button>
            </div>
          </div>
        </div>
      </div>
    </LayoutContainer>
  )
}

export const RadiationAlliance = ({userData, showLoader, closerLoader, onRefreshBalances}) => {

  const [radiationData, setRadiationData] = useState({
    status: false,
    statusCreator: false,
  })

  const [shareLink, setShareLink] = useState({
    status: false,
    msg: 'Share Referral Link',
  })

  const [uInterface, setUInterface] = useState({
    active: 'dashboard',
  })

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  useEffect(() => {
    if(userData.isConnected){
      getInfoRadiation(userData.username)
    }
    return () => {
      setRadiationData({
        status: false,
        statusCreator: false,
      })
    }
  }, [userData.isConnected]);

  const getInfoRadiation = (account) => {
    LoadRadiationTable(account).then(x => setRadiationData(x)) 
  }

  const handleInterface = (location) => setUInterface({
    active: location,
  })

  const handleCopy = () => {
    navigator.clipboard.writeText(`https://play.extinctionwars.com/ref=${userData.username}`)
    setShareLink({
      status: true,
      msg: 'Link Copied!'
    })
  }

  const claimRC = async(id) => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.EXTINCTION_CONTRACT,
          name: 'claimcreator',
          authorization: [userData.auths],
          data: {
            code: radiationData.dataCreator.code,
            option: id,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
          setTimeout(() => {
            onRefreshBalances();
          }, 500);
        })
      }catch(err){
        
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
        try{
            const action = {
                actions: [{
                    account: ExtinctionData.EXTINCTION_CONTRACT,
                    name: 'claimcreator',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                      code: radiationData.dataCreator.code,
                      option: id,
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setTimeout(() => {
                onRefreshBalances();
              }, 500);

          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
    }
  }
  
  if(!userData.isConnected){
    return (
      <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }
  
  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  if(!radiationData.status){
    return(
      <JoinScreen userData={userData} setRdata={setRadiationData}/>
    )
  }

  if(uInterface.active === 'dashboard'){
    return(
      <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)', padding:0, overFlow: 'hidden'}}>
      <div className='navbar_container_Radiation'>
        <div className='navigation_structurer_radiation'>
          <span className='nav_item_radiation active_nav_item_radiation'>Dashboard</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('shop')}>Shop</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('furnance')}>furnace</span>
          {radiationData.statusCreator && <span className='nav_item_radiation' onClick={() => handleInterface('creators')}>Creators</span>}
        </div>
      </div>
      <div className='activity_container_radiation'>
        <div className='referrer_data_structurer_radiation'>
          <div className='header_referrer_box'>
            <span>Referers: {radiationData.qty}</span>
            <span>Your RP: {radiationData.points}</span>
          </div>
          <div className='recent_refers_box'>
            <div className='title_referer_container'>
              <h4 className='title_referer'>last Referers</h4>
            </div>
            {radiationData.data.map((x) => (
              <div className='username_referer_box' key={x.survivorid}>
                <span>{x.survivorid}</span>
              </div>
            ))}
          </div>
          <div className='share_link_box'>
              <button className='alt_btn' onClick={() => handleCopy()}>{shareLink.msg}</button>
          </div>
        </div>
      </div>
    </LayoutContainer>
    )
  }


  if(uInterface.active === 'shop'){
    return(
      <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)', padding: '0', overflowY: 'hidden'}}>
      <div className='navbar_container_Radiation'>
        <div className='navigation_structurer_radiation'>
          <span className='nav_item_radiation' onClick={() => handleInterface('dashboard')}>Dashboard</span>
          <span className='nav_item_radiation active_nav_item_radiation'>Shop</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('furnance')}>furnace</span>
          {radiationData.statusCreator && <span className='nav_item_radiation' onClick={() => handleInterface('creators')}>Creators</span>}
        </div>
      </div>
      <div className='activity_container_radiation'>
        <div className='shop_structurer_container'>
          <ShopRpoints userData={userData}/>
        </div>
      </div>
    </LayoutContainer>
    )
  }

  if(uInterface.active === 'furnance'){
    return(
      <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)', padding:0, overFlow: 'hidden'}}>
      <div className='navbar_container_Radiation'>
        <div className='navigation_structurer_radiation'>
          <span className='nav_item_radiation' onClick={() => handleInterface('dashboard')}>Dashboard</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('shop')}>Shop</span>
          <span className='nav_item_radiation active_nav_item_radiation' style={{backgroundColor: '#232325'}}>furnace</span>
          {radiationData.statusCreator && <span className='nav_item_radiation' onClick={() => handleInterface('creators')}>Creators</span>}
        </div>
      </div>
      <div className='activity_container_radiation' style={{backgroundColor: '#191819', padding: '0'}}>
        <FurnaceInv userData={userData}/>
      </div>
    </LayoutContainer>
    )
  }

  if(uInterface.active === 'creators' && radiationData.statusCreator){
    return(
      <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)', padding:0, overFlow: 'hidden'}}>
        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        </div>
      <div className='navbar_container_Radiation'>
        <div className='navigation_structurer_radiation'>
          <span className='nav_item_radiation' onClick={() => handleInterface('dashboard')}>Dashboard</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('shop')}>Shop</span>
          <span className='nav_item_radiation' onClick={() => handleInterface('furnance')}>furnace</span>
          <span className='nav_item_radiation active_nav_item_radiation'>Creators</span>
        </div>
      </div>
      <div className='activity_container_radiation'>
      <div className='referrer_data_structurer_radiation'>
          <div className='header_creator_box'>
            <span>Your Code: {radiationData.dataCreator.code}</span>
            <span>Total Generated: {((Number(radiationData.dataCreator.suitcrate) * 18) + (Number(radiationData.dataCreator.wepcrate) * 18) + (Number(radiationData.dataCreator.doublecrate) * 30))} CP.</span>
          </div>
          <div className='recent_refers_box'>
              <div className='crator_structuer_data'>
                <div className='creator_titles_header'>
                  <h3>sales</h3>
                </div>
                <div className='creator_sales_body'>
                  <span>Suit Crates: {radiationData.dataCreator.suitcrate}</span>
                  <span>Weapon Crates: {radiationData.dataCreator.wepcrate}</span>
                  <span>Double Crates: {radiationData.dataCreator.doublecrate}</span>
                </div>
                <div className='btn_claim_container'>
                  <button onClick={() => claimRC(2)}>Claim in Wax</button>
                  <button onClick={() => claimRC(1)}>Claim in Onyx</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </LayoutContainer>
    )
  }

  
  /* return (
    <LayoutContainer styles_element={{backgroundColor: 'var(--dark-color)'}}>
      <div></div>
      <div></div>
    </LayoutContainer>
  ) */
}
